<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-toolbar-title>{{ tree.common_name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialog = false">Fechar</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <template>
          <v-tabs centered color="light-green darken-2" dark grow :icons-and-text="true">
            <v-tabs-slider color="yellow"></v-tabs-slider>

            <v-tab href="#tab-1">Informações
              <v-icon>info</v-icon>
            </v-tab>

            <v-tab href="#tab-2">Ficha Técnica
              <v-icon>list</v-icon>
            </v-tab>

            <v-tab href="#tab-3">Galeria
              <v-icon>image</v-icon>
            </v-tab>

            <v-tab-item id="tab-1">
              <v-card flat>
                <v-list three-line :expand="true">
                  <template>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Nome comum:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.common_name}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Família:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.family}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Subfamília:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.sub_family}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Nome científico:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.scientific_name}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Sinonímia botânica:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.botanical_synonymy}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Outros nomes comuns:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.other_common_names}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Ocorrência natural:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.natural_occurrence}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Bioma:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.biome}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Data da última atualização:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.last_update}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-card>
            </v-tab-item>

            <v-tab-item id="tab-2">
              <v-card flat>
                <v-list three-line>
                  <template>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Produção de mudas:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.producao_de_mudas}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Valor comercial da madeira:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.valor_comercial_da_madeira}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <div>
                          <h4>Produtos não madeireiros com valor comercial:</h4>
                        </div>
                        <div>{{tree.produtos_nao_madeireiros_com_valor_comercial}}</div>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <div>
                          <h4>Fixação biológica de nitrogênio:</h4>
                        </div>
                        <div>{{tree.fixacao_biologica_de_nitrogenio}}</div>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Velocidade de crescimento:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.velocidade_de_crescimento}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <div>
                          <h4>Potencial forrageiro dos frutos:</h4>
                        </div>
                        <div>{{tree.potencial_forrageiro_dos_frutos}}</div>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Potencial tóxico dos frutos:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.potencial_toxico_dos_frutos}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Tolerância ao fogo em pastagens:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.tolerancia_ao_fogo_em_pastagens}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <div>
                          <h4>Presença de raízes superficiais sob a copa:</h4>
                        </div>
                        <div>{{tree.presenca_de_raizes_superficiais_sob_a_copa}}</div>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Interferência no pasto sob a copa:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.interferencia_no_pasto_sob_a_copa}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Regeneração natural em pastagens:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.regeneracao_natural_em_pastagens}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Qualidade do fuste:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.qualidade_do_fuste}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Forma da copa em pastagens:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.forma_da_copa_em_pastagens}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Densidade da copa:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.densidade_da_copa}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>

                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <div>
                            <h4>Porte das árvores em pastagens:</h4>
                          </div>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <div>{{tree.porte_das_arvores_em_pastagens}}</div>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-card>
            </v-tab-item>

            <v-tab-item id="tab-3">
              <v-card flat>
                <template>
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm6
                        md4
                        lg4
                        xl3
                        class="px-1 py-1"
                        v-for="(item,i) in tree.pictures"
                        :key="i"
                      >
                        <v-card>
                          <v-img
                            :src="tree.cached === 1 ? item.base64 : item.image_path"
                            :lazy-src="tree.cached === 1 ? item.base64 : item.image_path"
                            :alt="item.description_of_image"
                            aspect-ratio="1"
                            height="100%"
                            class="grey lighten-2"
                          >
                            <v-layout slot="placeholder" fill-height align-center justify-center>
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                          </v-img>

                          <v-card-title primary-title>
                            <div>
                              <h3 class="headline mb-0">{{ item.description_of_image }}</h3>
                              <div>Por {{item.authorship}}</div>
                            </div>
                          </v-card-title>
                          <v-card-actions>
                            <v-btn
                              outline
                              color="success"
                              xs12
                              sm6
                              md4
                              lg4
                              xl3
                              @click="openImage(item)"
                            >
                              <v-icon left>aspect_ratio</v-icon>Abrir Original
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat small @click="openLicense()">
                              <img :src="'/static/img/license/' + item.license + '.png'">
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </template>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import base from '../contracts/tree.json'

export default {
  data () {
    return {
      dialog: false,
      windowWidth: 450,
      windowHeight: 200,
      tree: base,
      active: null
    }
  },
  methods: {
    show (tree) {
      this.tree = tree

      this.dialog = true
    },
    openLicense () {
      window.open('https://pt.wikipedia.org/wiki/Creative_Commons#Tipos_de_licen%C3%A7a')
    },
    openImage (picture) {
      if (picture.from_path === undefined) {
        window.open(picture.image_path, '_blank')
      } else {
        window.open(picture.from_path)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Info.vue